require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-elegant-solution-hornsby-residence-in-mansion-australia.json") })
        }
      }, "path---journal-elegant-solution-hornsby-residence-in-mansion-australia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-elegant-solution-hornsby-residence-in-mansion-australia!./.cache/json/journal-elegant-solution-hornsby-residence-in-mansion-australia.json
// module id = 483
// module chunks = 231608221292675